module.exports = __webpack_public_path__ + "img/ideal.cb0e41c.svg";